import { render, staticRenderFns } from "./PagePDPA.vue?vue&type=template&id=7d021653&"
import script from "./PagePDPA.vue?vue&type=script&lang=js&"
export * from "./PagePDPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports